(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (()=>{
 if(window.__nvCartWording)return;window.__nvCartWording=true;
 const relabel=()=>{
  document.querySelectorAll('.nv-cart-savings > span').forEach(node=>{
   if(/discount/i.test(node.textContent))node.textContent=document.getElementById('cart-drawer').dataset.savingsLabel;
  });
  document.querySelectorAll('#cart-drawer .cart-discounts').forEach(list=>{
   if(/discount/i.test(list.getAttribute('aria-label')||''))list.setAttribute('aria-label',document.getElementById('cart-drawer').dataset.savingsLabel);
  });
 };
 const watch=()=>{
  const drawer=document.getElementById('cart-drawer');
  if(!drawer)return;
  relabel();
  if(drawer.dataset.nvWatched)return;
  drawer.dataset.nvWatched='1';
  new MutationObserver(relabel).observe(drawer,{childList:true,subtree:true});
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',watch,{once:true});else watch();
 document.addEventListener('shopify:section:load',watch);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nuvana-offers"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('nuvana-offers'))customElements.define('nuvana-offers',class extends HTMLElement{
 connectedCallback(){
  this.abort?.abort();this.abort=new AbortController();const signal=this.abort.signal;
  this.form=this.closest('form');
  const planInput=this.querySelector('[data-nv-plan]');
  const sticky=this.querySelector('.nv-sticky-purchase');
  document.body.appendChild(sticky);this.sticky=sticky;
  const trigger=sticky.querySelector('[data-sticky-trigger]');const menu=sticky.querySelector('[data-sticky-menu]');
  const add=sticky.querySelector('[data-sticky-add]');
  const radios=()=>[...this.querySelectorAll('[data-nv-offer]')];
  const mode=()=>{const t=this.querySelector('[data-purchase][aria-pressed="true"]');return t?(t.dataset.purchase==='once'?'once':'sub'):'once';};
  const inMode=m=>radios().filter(r=>r.dataset.mode===(m||mode()));
  const chosen=()=>{const list=inMode();return list.find(r=>r.checked)||list.find(r=>r.hasAttribute('data-default'))||list[0];};
  const small=()=>matchMedia('(max-width: 749px)').matches;

  // One source of truth: the checked row in the current mode drives selling_plan, quantity and every label
  const sync=()=>{
   const r=chosen();if(!r)return;if(!r.checked)r.checked=true;
   const sub=r.dataset.mode==='sub';
   if(planInput){planInput.disabled=!sub;if(sub)planInput.value=r.dataset.plan;}
   const qty=this.form?.querySelector('[name="quantity"]');
   if(qty&&qty.value!==r.dataset.qty){qty.value=r.dataset.qty;qty.dispatchEvent(new Event('change',{bubbles:true}));}
   sticky.querySelector('[data-sticky-label]').textContent=r.dataset.title;
   sticky.querySelector('[data-sticky-sub]').textContent=small()?(sub?'Subscribe & save':'One-time'):(sub?'Subscribe · '+r.dataset.sub:'One-time · '+r.dataset.sub);
   const chip=sticky.querySelector('[data-sticky-save]');chip.textContent=r.dataset.save;chip.hidden=!r.dataset.save;
   /* 18 Oct (Nate): on phones the button names what she's buying, so $72 reads as 3 bottles, not one ('Add 3 bottles · $72') */
   const nb=Number(r.dataset.qty)||1;
   add.textContent=small()?'Add '+nb+(nb===1?' bottle':' bottles')+' · '+r.dataset.total:this.dataset.addLabel+' · '+r.dataset.total;
   const terms=this.querySelector('[data-nv-terms]')||this.form?.querySelector('[data-nv-terms]')||document.querySelector('.product-information [data-nv-terms]');if(terms){const n=Number(r.dataset.qty);terms.textContent=sub?terms.dataset.sub.replaceAll('[total]',r.dataset.total).replace('[every]',n===1?'month':n+' months'):terms.dataset.once;}
  };
  /* Renewal terms sit directly under Add to cart (US auto-renewal laws want them right by the button) */
  {const t=this.querySelector('[data-nv-terms]');const btn=document.querySelector('.product-information .add-to-cart-button');const after=btn&&(btn.closest('.product-form-buttons')||btn.parentElement);if(t&&after&&!after.contains(t)){t.classList.add('nv-offers__terms--under');after.after(t);}}
  const setMode=m=>{
   /* 23 Oct: the 90-day money-back tag on the photo is for subscriptions; one-time orders get 30 days, so it steps aside on Buy once */
   document.querySelectorAll('.product-information .nv-stamp').forEach(st=>{st.style.display=m==='once'?'none':'';});
   this.querySelectorAll('[data-purchase]').forEach(b=>b.setAttribute('aria-pressed',String((b.dataset.purchase==='once'?'once':'sub')===m)));
   radios().forEach(r=>{r.closest('.nv-offer').hidden=r.dataset.mode!==m;});
   sync();
  };
  this.renderMenu=()=>{
   const cur=chosen(),sub=mode()==='sub';
   const modes=planInput?'<div class="nv-sticky-modes" role="group" aria-label="Purchase type"><button type="button" data-sticky-kind="sub" aria-selected="'+sub+'">Subscribe &amp; save</button><button type="button" data-sticky-kind="once" aria-selected="'+(!sub)+'">Buy once</button></div><p class="nv-sticky-note">'+(sub?'Free US shipping · skip or cancel anytime':'Ships once, no subscription')+'</p>':'';
   const esc=s=>String(s||'').replace(/[&<>"]/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]));
   menu.innerHTML=modes+inMode().map(r=>'<button type="button" role="option" class="nv-sticky-opt" data-sticky-opt="'+esc(r.value)+'" aria-selected="'+(r===cur)+'"><span class="nv-sticky-opt__name">'+esc(r.dataset.title)+(r.dataset.save?'<span class="nv-sticky-chip">'+esc(r.dataset.save)+'</span>':'')+'</span><span class="nv-sticky-opt__sub">'+esc(r.dataset.sub)+'</span><span class="nv-sticky-opt__price">'+(r.dataset.was?'<s>'+esc(r.dataset.was)+'</s>':'')+esc(r.dataset.total)+'</span></button>').join('');
  };
  // Switching mode from the sticky menu re-lays out the buy box far above the reader; hold whatever is mid-screen in place (Safari has no scroll anchoring)
  this.keepPlace=fn=>{
   const pick=()=>document.elementsFromPoint(innerWidth/2,innerHeight/2).find(el=>!el.closest('.nv-sticky-purchase,header,#header-group')&&getComputedStyle(el).position!=='fixed');
   const anchor=pick();const before=anchor?.getBoundingClientRect().top;fn();
   if(!anchor)return;const fix=()=>{const d=anchor.getBoundingClientRect().top-before;if(Math.abs(d)>.5)window.scrollBy({top:d,behavior:'instant'});};
   fix();requestAnimationFrame(fix);setTimeout(fix,250);
  };
  this.toggleMenu=open=>{
   const next=open??menu.hidden;
   if(next)this.renderMenu();
   menu.hidden=!next;trigger.setAttribute('aria-expanded',String(next));
   if(next)menu.querySelector('[aria-selected="true"]')?.focus();
  };
  /* composedPath, not contains(): switching mode re-renders the menu, so the clicked button is already detached */
  document.addEventListener('click',e=>{if(e.isTrusted&&!menu.hidden&&!e.composedPath().includes(sticky))this.toggleMenu(false);},{signal});
  sticky.addEventListener('keydown',e=>{
   if(e.key==='Escape'&&!menu.hidden){this.toggleMenu(false);trigger.focus();}
   if((e.key==='ArrowDown'||e.key==='ArrowUp')&&!menu.hidden){e.preventDefault();const items=[...menu.querySelectorAll('.nv-sticky-opt')];const i=items.indexOf(document.activeElement);items[(i+(e.key==='ArrowDown'?1:-1)+items.length)%items.length]?.focus();}
  },{signal});
  this.addEventListener('change',e=>{if(e.target.matches('[data-nv-offer]'))sync();},{signal});
  const handleClick=e=>{
   if(e.target.closest('[data-sticky-trigger]')){this.toggleMenu();return;}
   const kind=e.target.closest('[data-sticky-kind]');
   if(kind){if(mode()!==kind.dataset.stickyKind)this.keepPlace(()=>setMode(kind.dataset.stickyKind));this.renderMenu();menu.querySelector('[data-sticky-kind="'+kind.dataset.stickyKind+'"]')?.focus();return;}
   const opt=e.target.closest('[data-sticky-opt]');
   if(opt){const r=inMode().find(x=>x.value===opt.dataset.stickyOpt);if(r){r.checked=true;sync();}this.toggleMenu(false);trigger.focus();return;}
   const tab=e.target.closest('[data-purchase]');
   if(tab&&this.contains(tab)){setMode(tab.dataset.purchase==='once'?'once':'sub');return;}
   if(e.target.closest('[data-sticky-add]')){sync();this.form?.querySelector('button[name="add"]')?.click();}
  };
  this.addEventListener('click',handleClick,{signal});sticky.addEventListener('click',handleClick,{signal});
  this.form?.addEventListener('submit',sync,{capture:true,signal});
  // The theme's add button posts via fetch on click (no submit event) and can reset the quantity field after load: sync right before every add
  this.form?.addEventListener('click',e=>{if(e.target.closest('button[name="add"],[type="submit"]'))sync();},{capture:true,signal});
  requestAnimationFrame(()=>{
   if(!this.isConnected)return;
   setMode(planInput?'sub':'once');
   const main=this.form?.querySelector('button[name="add"]');if(!main)return;
   const state=()=>{add.disabled=main.disabled;};state();
   this.busy=new MutationObserver(state);this.busy.observe(main,{attributes:true,attributeFilter:['disabled']});
   const footer=document.querySelector('[data-site-footer]');
   let footerVisible=false;
   // Re-read the buy button's live position on scroll: the observer only fires when it crosses the screen edge, so a jump to the top could leave the bar showing
   // Show and hide with the same gentle fade-and-rise; it's only removed (hidden) once the fade-out has finished
   const inner=sticky.querySelector('.nv-sticky-inner');const reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;
   let shown=false,hideTimer=0;
   const setShown=(on)=>{
    if(on===shown)return;shown=on;clearTimeout(hideTimer);
    if(on){sticky.hidden=false;sticky.classList.add('is-off');void sticky.offsetWidth;sticky.classList.remove('is-off');}
    else{this.toggleMenu(false);sticky.classList.add('is-off');if(reduce)sticky.hidden=true;else hideTimer=setTimeout(()=>{if(!shown)sticky.hidden=true;},650);}
   };
   inner?.addEventListener('transitionend',e=>{if(e.target===inner&&e.propertyName==='opacity'&&!shown)sticky.hidden=true;},{signal});
   /* 14 Oct 2026 (Nate): phones and laptops alike, the bar appears only once the real add-to-cart button has scrolled fully up out of view (it used to show on phones from the first screen) *//* 20 Oct: no scroll listener at all now. The observer says when the button has left the screen and which way (above = scrolled past) */let off=false;const visibility=()=>{setShown(off&&!footerVisible);};
   this.observer=new IntersectionObserver((es)=>{const e=es[es.length-1];off=!e.isIntersecting&&e.boundingClientRect.bottom<0;visibility();},{threshold:0});
   this.observer.observe(main);
   if(footer){this.footerObserver=new IntersectionObserver(([entry])=>{footerVisible=entry.isIntersecting;visibility();});this.footerObserver.observe(footer);}
  });
 }
 disconnectedCallback(){this.sticky?.remove();this.abort?.abort();this.busy?.disconnect();this.observer?.disconnect();this.footerObserver?.disconnect();}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-information-content"] && !Shopify.designMode) return;
  try {
    (()=>{
 const init=()=>document.querySelectorAll('.product-information__grid').forEach(grid=>{
  if(grid.dataset.nvGeometry)return;grid.dataset.nvGeometry='true';
  const media=grid.querySelector('.product-information__media'),card=grid.querySelector('.product-details'),last=grid.querySelector('.nv-offers__choices');if(!media||!card||!last)return;
  let frame;const measure=()=>{cancelAnimationFrame(frame);frame=requestAnimationFrame(()=>{if(!grid.isConnected)return;if(!matchMedia('(min-width:990px)').matches){media.style.removeProperty('--nv-media-height');media.style.removeProperty('--nv-media-inset');return;}const inset=Math.max(0,innerWidth-card.getBoundingClientRect().right-media.getBoundingClientRect().left);media.style.setProperty('--nv-media-inset',inset+'px');const top=grid.getBoundingClientRect().top;const height=last.getBoundingClientRect().bottom-top;if(height>0)media.style.setProperty('--nv-media-height',height+'px');});};
  const observer=new ResizeObserver(measure);observer.observe(card);observer.observe(last);measure();window.addEventListener('resize',measure,{passive:true});
 });
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();document.addEventListener('shopify:section:load',init);
})();
  } catch(e) { console.error(e); }
})();

})();
